export default "__VITE_ASSET__FfFMXtA2__"